const indexes = [
  {
    id: 1,
    title: '今日更新',
    desc: '每日同步最新漫画章节，追更永远快人一步',
    icon: 'ri-calendar-check-line',
    accent: 'primary',
  },
  {
    id: 2,
    title: '新作推荐',
    desc: '编辑精选优质新作，发现下一部心头好',
    icon: 'ri-star-line',
    accent: 'accent',
  },
  {
    id: 3,
    title: '热门连载',
    desc: '全网人气连载漫画专区，人气最高的都在这里',
    icon: 'ri-fire-line',
    accent: 'primary',
  },
  {
    id: 4,
    title: '完结精品',
    desc: '已完结漫画一次读个够，拒绝追更等待',
    icon: 'ri-check-double-line',
    accent: 'secondary',
  },
  {
    id: 5,
    title: '国漫之光',
    desc: '国漫崛起力作集结，国产漫画精选专区',
    icon: 'ri-flag-line',
    accent: 'primary',
  },
  {
    id: 6,
    title: '日漫经典',
    desc: '日漫经典名作与最新番剧，一网打尽',
    icon: 'ri-earth-line',
    accent: 'accent',
  },
  {
    id: 7,
    title: '韩漫热榜',
    desc: '韩漫热门作品排行榜，潮流漫画抢先看',
    icon: 'ri-bar-chart-line',
    accent: 'secondary',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫画大全索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            九妖漫画网为您整理了最全面的漫画分类索引，快速找到想看的作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexes.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 cursor-pointer transition-all duration-200"
            >
              <span className={`w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl text-lg ${
                item.accent === 'primary'
                  ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                  : item.accent === 'accent'
                  ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                  : 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
              } transition-colors`}>
                <i className={item.icon}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-1 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}